import { inject } from 'vue'
import { jdPaginationKey } from './constants'

export const usePagination = () => inject(jdPaginationKey, {})
